// extracted by mini-css-extract-plugin
export var arrows = "_58-6";
export var decrementer = "_58-a";
export var disabled = "_58-4";
export var error = "_58-1";
export var hiddenText = "_58-b";
export var incrementer = "_58-9";
export var input = "_58-8";
export var inputWrapper = "_58-0";
export var leadingIcon = "_58-c";
export var readonly = "_58-3";
export var regular = "_58-7";
export var small = "_58-5";
export var warning = "_58-2";